import React from 'react';
import MarkdownLayout from '../../Layout/MarkdownLayout';

const FairPlayPolicyContainer = () => {
    return <MarkdownLayout title={'Fair Play Policy'} mdFileName={'FairPlayPolicy'} />;
};

export default FairPlayPolicyContainer;
